import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiClientsService } from '../../services/apiClients.service';
import { Router } from '@angular/router';
import { ErrorService } from '../../services/error.service';
import { action } from '../../util/enums'
import { TenantsService } from '../../services/tenants.service';
import { SingleTableModel, AccessAssociation } from '../../models/singleTableModel';
import { AuthService } from '../../services/auth.service';
import { map, Observable } from 'rxjs';

@Component({
  selector: '[appApiClientDetails]',
  templateUrl: './apiClientDetails.component.html',
  styleUrls: ['./apiClientDetails.component.css'],
  standalone: false
})
export class ApiClientDetailsComponent implements OnInit {
  @Input() client!: SingleTableModel;
  isTenantClient: boolean = false;
  isMerchantClient: boolean = false;
  isAdminClient: boolean = false;
  @Input() action!: string;
  @Output() postActionEvent = new EventEmitter<string>();
  actionHappening: action = action.nothing;
  isLoading: boolean = false;
  initialClient = new SingleTableModel('', '', '', '', true, 'api-client', '', '', '', '', '', 0, '', '', 'tenant', localStorage.getItem('UserName') ?? '','');
  displayStyle: string = "none";
  entityName: string = '';
  isActiveCssClass = 'form-check form-switch';
  isPortalClientCssClass = 'form-check form-switch';
  isApiClientCssClass = 'form-check form-switch';
  errorMessage: string = '';
  apiTenants: AccessAssociation[] = [];
  apiMerchants: AccessAssociation[] = [];
  filteredApiTenants: AccessAssociation[] = [];
  filteredApiMerchants: AccessAssociation[] = [];
  tenantsSelected: number = 0;
  searchTenantId: string = '';
  
  apiTenantPage: number = 1;
  apiMerchantPage: number = 1;

  constructor(private clientsService: ApiClientsService, private router: Router, private errorService: ErrorService, private tenantsService: TenantsService, private authService: AuthService) {

  }
  ngOnInit(): void {
    this.isAdminClient = this.authService.IsAdminUser$.value;
    this.isTenantClient = this.authService.IsTenantUser$.value;
    this.isMerchantClient = this.authService.IsMerchantUser$.value;
    this.apiTenants = [];
    this.tenantsSelected = 0;
    if (this.action != 'view') {
      this.loadAssociations('update');
    }
  }

  updateAction(action: string) {
    this.action = action;
    if (this.action == 'update') {
      this.postActionEvent.emit(JSON.stringify(this.client));
      //this.loadAssociations(action);
    }
  }

  disableClient(updatedAction: string) {
    this.isActiveCssClass = 'spinner-border spinner-border-sm';
    this.actionHappening = action.disable;
    this.isLoading = true;
    this.clientsService.disableClient(this.client).subscribe((updatedClient) => {
      this.action = updatedAction;
      alert(updatedClient.message);
      this.postAction('refresh');
    },
      (error) => {
        this.errorService.alertError(error);
        this.postAction('refresh');
      }
    )
  }

  openConfirmationDialog() {
    this.actionHappening = action.delete;
    this.entityName = this.client.id;
    this.displayStyle = 'block';
  }

  confirmDelete(isConfirmed: boolean) {
    if (isConfirmed) {
      this.deleteClient('view');
    }
    else {
      this.actionHappening = action.nothing;
    }
  }

  deleteClient(updatedAction: string) {
    if (this.client.isActive) {
      alert('An active client cannot be deleted');
      this.actionHappening = action.view;
      return;
    }
    this.actionHappening = action.delete;
    this.isLoading = true;
    this.clientsService.deleteClient(this.client.id, this.client.accessKey).subscribe((updatedClient) => {
      this.action = updatedAction;
      alert(updatedClient.message);
      this.postAction('refresh');
    },
      (error) => {
        this.errorService.alertError(error);
        this.postAction('refresh');
      }
    )
  }

  cancelEdit(updatedAction: string) {
    this.postAction('reload');
  }

  cancelCreate(updatedAction: string) {
    this.initialClient.name = '';
    this.initialClient.id = '';
    this.client.name = '';
    this.client.id = '';
    this.postAction('reload');
  }

  checkAccessAssociation(clientType: string): string | undefined {
    if (clientType === 'tenant' || clientType === 'terminal') {
      return this.apiTenants
        .filter((x: AccessAssociation) => x.isAssociated)
        .map(association => association.value)
        .join(',');
    } else if (clientType === 'merchant') {
      return this.apiMerchants
        .filter((x: AccessAssociation) => x.isAssociated)
        .map(association => association.value)
        .join(',');
    }
  
    return undefined; 
  }
  
  
  findIsClientExists(clientId: string): Observable<boolean> {
    return this.clientsService.getClient(clientId).pipe(
      map((response) => !!response.Item) 
    );
  }
  

  createClient(updatedAction: string) {
    this.actionHappening = action.create;
    this.isLoading = true;

    this.findIsClientExists(this.client.id).subscribe((isClientExist: boolean) => {

      if (isClientExist) {
        this.actionHappening = action.nothing;
        this.isLoading = false;
        alert('API client ID already exists. Please use a different ID.');
        return;
      }

      this.client.accessAssociation = this.checkAccessAssociation(this.client.clientType) as string;

      if (!this.client.accessAssociation) {
        this.actionHappening = action.nothing;
        this.isLoading = false;
        alert('Please associate the client with any tenant.');
        return;
      }

      this.clientsService.createClient(this.client).subscribe(
        createdClient => {
          this.action = updatedAction;
          if (createdClient.message !== undefined) {
            alert(createdClient.message);
          } else {
            alert('ApiClient created successfully with ApiClient ID ' + createdClient.clientId + ' and AccessKey ' + createdClient.apiKey);
          }
          this.postAction('refresh');
        },
        error => {
          this.errorService.alertError(error);
          this.actionHappening = action.nothing;
          this.isLoading = false;
        }
      );

    })

  }
  

  updateClient(updatedAction: string) {
    var clientNameRegex = new RegExp(/^[a-zA-Z0-9 ]{1,50}$/)
    var emailRegex = new RegExp(/^[A-Za-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{1,4}[^\\S]+$/);
    if (!clientNameRegex.test(this.client.name) || this.client.name.length > 50 || this.client.name.length < 1) {
      alert('Please enter valid client name');
      return;
    }
    this.actionHappening = action.update;
    this.isLoading = true;
    

    if (this.client.clientType == 'tenant' || this.client.clientType == 'terminal') {
      this.client.accessAssociation = this.apiTenants.filter((x: AccessAssociation) => x.isAssociated).map(function (association) { return association.value }).join(',');
    }
    else if (this.client.clientType == 'merchant') {
      this.client.accessAssociation = this.apiMerchants.filter((x: AccessAssociation) => x.isAssociated).map(function (association) { return association.value }).join(',');
    }

    if (this.client.accessAssociation == '') {
      this.actionHappening = action.nothing;
      this.isLoading = false;
      alert('Please associated the client with any tenant.');
      return;
    }
    this.clientsService.updateClient(this.client).subscribe((updatedClient) => {
      this.action = updatedAction;
      if (updatedClient.message != undefined)
        alert(updatedClient.message);
      else
        alert('ApiClient created successfully with ApiClient id ' + updatedClient.clientId + ' and AccessKey ' + updatedClient.apiKey);
      this.postAction('refresh');
    },
      (error) => {
        this.errorService.alertError(error);
        this.postAction('refresh');
      }
    )
  }

  saveClient(updatedAction: string) {
    if (this.action == 'view') {
      this.initialClient = this.client;
      this.action = updatedAction;
    }
  }

  postAction(value: string) {
    this.postActionEvent.emit(value);
  }

  resetAssociations() {
    this.apiTenants = [];
    this.tenantsSelected = 0;
    this.searchTenantId = '';
  }

  apiTenantSelected(checked : boolean) {
    this.tenantsSelected = checked ? this.tenantsSelected + 1 : this.tenantsSelected - 1;
  }

  loadAssociations(updatedAction: string) {
    this.resetAssociations();
    if (this.client.clientType == 'tenant' || this.client.clientType == 'terminal') {
      this.loadAllApiTenantAssociations(updatedAction);
    }
  }

  loadAllApiTenantAssociations(updatedAction: string) {
    this.apiTenants = [];
    this.filteredApiTenants = [];
    this.tenantsSelected = 0;
    this.isActiveCssClass = 'spinner-border spinner-border-sm';
    this.actionHappening = action.disable;
    this.isLoading = true;
    if (this.isAdminClient) {
      this.tenantsService.getAllTenants().subscribe((tenants) => {
        if (tenants.hasOwnProperty('message')) {
          this.errorMessage = tenants.message;
        }
        else {
          if (tenants.hasOwnProperty('Item')) {
            this.apiTenants.push((new AccessAssociation(tenants.Item.tenantId, tenants.Item.tenantId + '|' + tenants.Item.accessKey)));
          }
          else {
            this.apiTenants.push(...(tenants.Items.filter((x: SingleTableModel) => x.isActive).map(function (a: SingleTableModel) { return new AccessAssociation(a.id, a.id + '|' + a.accessKey); })));
          }

          this.apiTenants.forEach((a) => {
            a.isAssociated = this.client.accessAssociation.indexOf(a.value) != -1 ? true : false;
            if (a.isAssociated)
              this.tenantsSelected = this.tenantsSelected + 1;
          });
        }
        this.filteredApiTenants.push(...this.apiTenants);
        this.isLoading = false;
      }, (error) => {
        this.isLoading = false;
        this.errorMessage = this.errorService.alertError(error);
      });
    }
    else {
      {
        this.tenantsService.getUserTenants(this.authService.AccessDetails$.value.AccessAssociation).subscribe((tenants) => {
          if (tenants.hasOwnProperty('message')) {
            this.errorMessage = tenants.message;
          }
          else {
            if (tenants.hasOwnProperty('Item')) {
              this.apiTenants.push((new AccessAssociation(tenants.Item.tenantId, tenants.Item.tenantId + '|' + tenants.Item.accessKey)));
            }
            else {
              this.apiTenants.push(...(tenants.filter((x: SingleTableModel) => x.isActive).map(function (a: SingleTableModel) { return new AccessAssociation(a.id, a.id + '|' + a.accessKey); })));
            }

            this.apiTenants.forEach((a) => {
              a.isAssociated = this.client.accessAssociation.indexOf(a.value) != -1 ? true : false;
            });
          }
          this.filteredApiTenants.push(...this.apiTenants);
          this.isLoading = false;
        }, (error) => {
          this.isLoading = false;
          this.errorMessage = this.errorService.alertError(error);
        });
      }
    }
  }

  searchTenants() {
    if (this.apiTenants.length > 0) {
      this.filteredApiTenants = [];

      this.filteredApiTenants.push(...this.apiTenants.filter((x) =>
        (x.name?.toLowerCase().includes(this.searchTenantId.toLowerCase()))));
      this.apiTenantPage = 1;
    }
  }

  reloadTenants() {
    this.searchTenantId = '';
    if (this.apiTenants.length > 0) {
      this.filteredApiTenants = [];

      this.filteredApiTenants.push(...this.apiTenants);
      this.apiTenantPage = 1;
    }
  }


  reloadMerchants() {
    if (this.apiMerchants.length > 0) {
      this.filteredApiMerchants = [];

      this.filteredApiMerchants.push(...this.apiMerchants);
      this.apiMerchantPage = 1;
    }
  }

  searchForMerchants() {
    if (this.apiMerchants.length > 0) {
      this.filteredApiMerchants = [];

      this.filteredApiMerchants.push(...this.apiMerchants.filter((x) =>
        (x.value?.split('|')[0].toLowerCase().includes(this.searchTenantId.toLowerCase()))));
      this.apiMerchantPage = 1;
    }
  }

}
